'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComplexMovementPreparation = function (_Component) {
  (0, _inherits3.default)(ComplexMovementPreparation, _Component);

  function ComplexMovementPreparation() {
    (0, _classCallCheck3.default)(this, ComplexMovementPreparation);
    return (0, _possibleConstructorReturn3.default)(this, (ComplexMovementPreparation.__proto__ || (0, _getPrototypeOf2.default)(ComplexMovementPreparation)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComplexMovementPreparation, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_reactHelmet2.default, { title: 'V\u0161estrann\xFD pohybov\xFD rozvoj', link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/vsestranny-pohybovy-rozvoj' }] }),
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'h1',
              null,
              'V\u0161estrann\xFD pohybov\xFD rozvoj'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Hlavn\xED na\u0161\xED motivac\xED je, aby d\u011Bti sport bavil. Nejsme zam\u011B\u0159eni pouze na atletiku. D\u011Bti se u n\xE1s nau\u010D\xED z\xE1klad\u016Fm:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'gymnastiky'
              ),
              _react2.default.createElement(
                'li',
                null,
                'm\xED\u010Dov\xFDch her'
              ),
              _react2.default.createElement(
                'li',
                null,
                'lezen\xED'
              ),
              _react2.default.createElement(
                'li',
                null,
                'bruslen\xED '
              ),
              _react2.default.createElement(
                'li',
                null,
                'inline bruslen\xED'
              ),
              _react2.default.createElement(
                'li',
                null,
                'kolob\u011Bhu'
              ),
              _react2.default.createElement(
                'li',
                null,
                'plav\xE1n\xED'
              ),
              _react2.default.createElement(
                'li',
                null,
                'ly\u017Eov\xE1n\xED'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'D\u011Bti nau\u010D\xEDme z\xE1klad\u016Fm sport\u016F, kter\xE9 vyu\u017Eij\xED v\xA0b\u011B\u017En\xE9m \u017Eivot\u011B, nejen na vrcholov\xE9 \xFArovni. Mysl\xEDme si, \u017Ee nen\xED d\u016Fle\u017Eit\xE9 se do 13 let zam\u011B\u0159ovat pouze na rozvoj jedn\xE9 \u010Dinnosti, ale vn\xEDmat sport jako celek. Nau\u010Dit se m\xEDt ho r\xE1d, z\xEDskat nov\xE9 kamar\xE1dy a zapojovat se spole\u010Dn\u011B do kolektivu.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'V\xA0pr\u016Fb\u011Bhu cel\xE9ho roku po\u0159\xE1d\xE1me soust\u0159ed\u011Bn\xED a p\u0159\xEDm\u011Bstsk\xE9 t\xE1bory, kter\xE9 jsou zam\u011B\u0159en\xE9 na r\u016Fzn\xE9 druhy sport\u016F a pohyb. D\u016Fle\u017Eit\xE9 pro n\xE1s je, aby d\u011Bti lekce bavily a ned\u011Blaly nic z\xA0donucen\xED.'
            )
          )
        )
      );
    }
  }]);
  return ComplexMovementPreparation;
}(_react.Component);

exports.default = ComplexMovementPreparation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ComplexMovementPreparation/ComplexMovementPreparation.js
// module id = 1105
// module chunks = 0